var $ = require('jquery')
  , ListModel = require('./models/ListModel')
  , MainContainer = require('./views/MainContainer')
  , QrCodeContainer = require('./views/QrCodeContainer')
  , FilterNav = require('./views/FilterNav')
  , detector = require('widgets/detector')

require('@173js/ui/preventEmptyHrefClick')

var win = $(window)

function setupPjaxFilter() {

  var listModel = new ListModel()

  var mainContainer = new MainContainer({
    el: $('.pn-game-all')
    , model: listModel
  })
  mainContainer.render()

  var filterNav = new FilterNav({
    el: $('.pn-game-filter')
    , model: listModel
  })

  filterNav.render()

  win.on('popstate', function () {
    listModel.trigger('changeRoute')
  })
}

function getToolHtml(data, el) {
  // console.log('data', data)
  var types = ['510324,注册指南,zczn', '510325,游戏加速,yxjs', '510326,组队,zd', '510327,充值,cz', '510328,汉化,hh', '510329,玩家交流群,ghzr']
  var tools = {}
  types.forEach(v => {
    const [key, name, classname, links] = [...v.split(','), []]
    tools[key] = { name, classname, links }
  })
  data.forEach((item, index) => {
    item.categoryIds.split(',').forEach(v => {
      if (tools[v] && tools[v].links.length < 2) {
        tools[v].links.push(
          {
            title: item.smallTitle,
            url: item.pageUrl
          }
        )
      }
    })
  })
  var toolsItemHtml = []
  types.forEach((v, i) => {
    var typeId = []
    typeId.push(v.split(',')[0])
    tools[typeId].links.length > 0 && toolsItemHtml.push(`
        <div class="item ${v.split(',')[2]}">
          <div class="tit">${v.split(',')[1]}</div>
          <ul class="list">
            ${tools[typeId].links.map((item) => `<li><a href="${item.url}" target="_blank">${item.title}</a></li>`).join('')}
          </ul>
        </div>
      `
    )
  })
  el.append(
    `<div class="mod-tool">
      <div class="hd">
        <div class="tit">外服指南</div>
      </div>
      <div class="bd">
        <div class="tools">
          ${toolsItemHtml.join('')}
        </div>
      </div>
    `
  )
}

function getGameCode() {
  let gameCodes = ''
  let gameCodesArr = []
  $('.ptlist-pc li').each(function () {
    gameCodes += `${$(this).find('.channel a').last().attr('href').split('.html')[0].split('list-')[1]},`
    gameCodesArr.push($(this).find('.channel a').last().attr('href').split('.html')[0].split('list-')[1])
  })
  gameCodes && $.ajax({
    type: "get",
    url: '//interface.17173.com/content/list.jsonp',
    dataType: "jsonp",
    data: {
      categoryIds: "510324,510325,510326,510327,510328,510329",//所属分类，多个用逗号隔开
      channelCode: 90117,//频道编号
      oldGameCodes: gameCodes,
      pageNo: 1,//默认1
      pageSize: 50,//默认20，最大值200
    },
    success: function (data) {
      // console.log(data)
      let games = {}
      data.data.forEach(function (v, i) {
        v.oldGameCodes.split(',').forEach(function (j) {
          if (!games[j]) {
            games[j] = []
          }
          games[j].push(v)
        })
      })

      // console.log('games', games)
      // 工具tool
      for (const key in games) {
        if (games.hasOwnProperty(key)) {
          getToolHtml(games[key], $(`.ptlist-pc p.tit a[href*=${key}]`).parents('li'))
        }
      }
    }
  })
}

$(function () {
  var qrCodeContainer = new QrCodeContainer({
    el: $('.pn-game-all')
  })
  qrCodeContainer.render()

  if (!detector.hasPushState()) { return }
  setupPjaxFilter()
  getGameCode()
})
